import { useAuth } from "@/app/components/auth-context";

/**
 * Returns the current user's businessId from the JWT.
 * Staff-web is single-business — no URL-based businessId like rebookt-web.
 */
export function useBusinessId(): string {
  const { currentUser } = useAuth();
  return currentUser?.businessId ?? "";
}
